import Card from "./Card";
export default Card;

export type { CardProps } from './Card.interface';